import {
  Input,SimpleChanges,OnChanges,
  Component,
  OnInit
} from '@angular/core';
import {MarkerVMModel} from "../../models/MarkerModel";
import {WorkSpaceVMModel} from "../../models/WorkSpaceVMModel";
import { GoogleMapsAPIWrapper,LatLng,LatLngBounds } from '@agm/core';
import {ZoomControlOptions, ControlPosition,ZoomControlStyle} from "@agm/core/services/google-maps-types";


const L = window['L']; // 'L' is not found if it is not defined here (leaflet map)
@Component({

  selector: 'rw-map',  // <home></home>

  styles: [require('./map.component.css')],
  /**
   * Every Angular template is first compiled by the browser before Angular runs it's compiler.
   */
  template: require('./map.component.html')
})
export class MapComponent implements OnInit,OnChanges {


  @Input() public currentLocation:MarkerVMModel;
  @Input() public workSpaceList:WorkSpaceVMModel[] = [];
  @Input() public height;
  public mapStyle:any = {'height': '50px'};

  public zoom:number = 12;
  public zoomControlOptions:ZoomControlOptions = {position: ControlPosition.BOTTOM_LEFT, style: ZoomControlStyle.SMALL}
  public fitBounds:LatLngBounds;
  mymap = null;
  mapboxgl = null;
  leafletMap =null;
  marker = null;
  /**
   * TypeScript public modifiers
   */
  constructor(private googleMapsAPI:GoogleMapsAPIWrapper) {
  }

  public ngOnInit() {
    // navigator.geolocation.getCurrentPosition(showPosition => {
    //   this.mapShow(showPosition.coords.latitude, showPosition.coords.longitude);
    // });

    this.initLeaflet();
    // this.initMapBox();


  }

  initLeaflet(){

    let lat = 51.505;
    let lng = 53;
    if (this.currentLocation) {
      lat = this.currentLocation.lat;
      lng = this.currentLocation.lng;
    }

    this.leafletMap = L.map('mapid').setView([lat, lng], 13);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.planovin.com">Planovin</a>'
    }).addTo(this.leafletMap);

    this.showLeafletMap(lat,lng);
  }

  showLeafletMap(lat,lng){

    if(this.leafletMap){
      this.leafletMap.setView([lat, lng], 13);

      if(this.marker)
        this.leafletMap.removeLayer(this.marker);
      this.marker = L.marker([lat, lng]).addTo(this.leafletMap);
    }
  }



  ngOnChanges(changes:SimpleChanges):void {
    let parent = this;
    if(this.currentLocation) {
      this.showLeafletMap(this.currentLocation.lat, this.currentLocation.lng);
    }
  }


  openGoogleMap(){
    let mapUrl = "https://www.google.com/maps?q="+this.currentLocation.lat+","+this.currentLocation.lng;
    window.open(mapUrl,"_blank");
  }

  // initMapBox(){
  //   this.mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');
  //   // this.mapboxgl.accessToken = 'pk.eyJ1IjoibWptYWppZGYiLCJhIjoiY2tjNGpzcWFzMDhpOTJxbnU1OTk1ZjQyZyJ9.pWVBFzPmuog2zlf1MD2ubg';
  //   this.mapboxgl.accessToken = 'pk.eyJ1IjoibWotbWFqaWQtZmF0dGFoaSIsImEiOiJja3U1YjN3djUwNjE5MnFwYXZzcm1tczJhIn0.FLWOyjGqBEh9C5CT3gNyyQ';
  //
  //   this.mapboxgl.setRTLTextPlugin(
  //     'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
  //     null,
  //     true // Lazy load the plugin
  //   );
  //
  //   if (this.currentLocation) {
  //     this.mapShow(this.currentLocation.lat, this.currentLocation.lng);
  //
  //   }
  //   if (this.workSpaceList) {
  //
  //   }
  // }
  // mapShow(latit, longit){
  //   // It has error on calling 'L' which is from leaflet, however it works!!!
  //   setTimeout(() => {
  //     let mapX;
  //     let mapY;
  //     let initZoom=11;
  //
  //     if (this.currentLocation.lat && this.currentLocation.lng){
  //       mapX = this.currentLocation.lat;
  //       mapY =  this.currentLocation.lng;
  //     } else {
  //       mapX = 35.69439;
  //       mapY = 51.42151;
  //
  //     }
  //
  //     if(this.mymap)
  //     {
  //       this.mymap.off();
  //       this.mymap.remove();
  //     }
  //     this.mymap   = new this.mapboxgl.Map({
  //       container: 'locationMap',
  //       style: 'mapbox://styles/mapbox/streets-v11',
  //        center: [mapY, mapX], // starting position
  //       zoom: initZoom // starting zoom
  //     });
  //     this.mymap.addControl(
  //       new this.mapboxgl.GeolocateControl({
  //         positionOptions: {
  //           enableHighAccuracy: true
  //         },
  //         trackUserLocation: true
  //       })
  //     );
  //     var marker = new this.mapboxgl.Marker()
  //       .setLngLat([mapY, mapX])
  //       .addTo(this.mymap);
  //
  //
  //
  //     // L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
  //     //   // attribution: 'Mapسامانه نوبت دهی و رزرو آنلاین data &copy; <a href="https://www.reserweb.ir/">رزروب</a>',
  //     //   attribution: 'سامانه نوبت دهی و رزرو آنلاین &copy; <a style="font-weight: bold;" href="https://www.reserweb.ir/">رزروب</a>',
  //     //   maxZoom: 18,
  //     //   // id: 'mapbox.streets',
  //     //   // accessToken: 'your.mapbox.access.token'
  //     //   id: 'rakshak.l937n12c',
  //     //   // accessToken: 'pk.eyJ1IjoicmFrc2hhayIsImEiOiJ5cHhqeHlRIn0.Vi87VjI1cKbl1lhOn95Lpw'
  //     //   accessToken: 'pk.eyJ1IjoibWptYWppZGYiLCJhIjoiY2tjNGpzcWFzMDhpOTJxbnU1OTk1ZjQyZyJ9.pWVBFzPmuog2zlf1MD2ubg'
  //     // }).addTo(mymap);
  //     // var marker = L.marker([mapX, mapY], {
  //     //   // draggable: true
  //     // }).addTo(mymap);
  //
  //     // marker.on('drag', function () {
  //     //   // get and display lanLng of the marker while dragging
  //     //   var coordinate = marker.getLatLng();
  //     //
  //     //   this.currentLocation.lat = coordinate.lat;
  //     //   this.currentLocation.lng = coordinate.lng;
  //     //
  //     // });
  //   }, 1000);
  // }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/map/map.component.ts